import './Spinner.scss';

export const Spinner = ({ text }: { text: string }) => (
  <div
    className="loader"
    role="status"
    aria-live="polite"
    aria-label={text || 'Loading artifacts'}
  >
    <div className="loader__container">
      <div
        className="loader__spinner"
        role="progressbar"
        aria-label={text || 'Loading artifacts'}
        data-testid="loader__spinner"
      >
        {text && <div className="loader__text">{text}</div>}
      </div>
    </div>
  </div>
);
